export interface PrescriptionState {
  savingUpdate: boolean;
}

export const initialPrescriptionState: PrescriptionState = {
  savingUpdate: false,
};
